/* global axios */
import ApiClient from '../ApiClient';

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({ assistantId, messageContent, messageHistory }) {
    return axios.post(`${this.url}/${assistantId}/playground`, {
      message_content: messageContent,
      message_history: messageHistory,
    });
  }

  export(id) {
    return axios.get(`${this.url}/${id}/export`, {
      responseType: 'blob',
    });
  }

  systemPromptBlocks(id) {
    // EASYDESK PATCH-SITE: Load scenario core prompt blocks lazily for the
    // settings page so assistant list/show payloads stay small.
    return axios.get(`${this.url}/${id}/system_prompt_blocks`);
  }

  import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  exportFaqs(id, status = null) {
    const params = status ? { status } : {};
    return axios.get(`${this.url}/${id}/export_faqs`, {
      params,
      responseType: 'blob',
    });
  }

  importFaqs(id, file, options = {}) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append(
      'duplicate_strategy',
      options.duplicateStrategy || 'update'
    );
    formData.append('target_status', options.targetStatus || 'pending');

    return axios.post(`${this.url}/${id}/import_faqs`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new CaptainAssistant();
